import { render, staticRenderFns } from "./cover-editor.vue?vue&type=template&id=02ea836c&scoped=true"
import script from "./cover-editor.vue?vue&type=script&lang=js"
export * from "./cover-editor.vue?vue&type=script&lang=js"
import style0 from "./cover-editor.vue?vue&type=style&index=0&id=02ea836c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ea836c",
  null
  
)

export default component.exports